import { useEffect } from 'react'
import Lenis from 'lenis'
import { useMediaQuery } from './useMediaQuery'

/**
 * Smooth (inertial) scrolling for the public marketing site.
 *
 * Desktop, fine-pointer viewports only: touch devices already have inertial
 * scrolling and double-smoothing fights the OS, and `prefers-reduced-motion`
 * turns it off entirely. Native anchor jumps and keyboard scrolling keep
 * working — Lenis virtualises the wheel, nothing else.
 */
export function useSmoothScroll(): void {
  const fine = useMediaQuery('(hover: hover) and (pointer: fine)')
  const reduced = useMediaQuery('(prefers-reduced-motion: reduce)')
  const enabled = fine && !reduced

  useEffect(() => {
    if (!enabled) return

    const lenis = new Lenis({
      // Gentle glide: long enough to feel editorial, short enough that the
      // page never lags the scrollbar noticeably.
      lerp: 0.12,
      wheelMultiplier: 1,
    })

    let frame: number
    const raf = (time: number) => {
      lenis.raf(time)
      frame = requestAnimationFrame(raf)
    }
    frame = requestAnimationFrame(raf)

    return () => {
      cancelAnimationFrame(frame)
      lenis.destroy()
    }
  }, [enabled])
}
